import { SearchOutlined } from '@ant-design/icons';
import { FormHandler } from '@framework/form';
import { useTranslation } from '@framework/i18n';
import {
  GhostCollapse,
  IFilterPanelProps,
  ResponsiveCard,
  VerticalSpace,
} from '@framework/ui';
import { AnyObject } from '@framework/validation';
import { Button, Divider, Space } from 'antd';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';

export interface ITableDataFilterPanelProps<T extends AnyObject>
  extends IFilterPanelProps<T> {}

export function TableDataFilterPanel<T extends AnyObject>(
  props: ITableDataFilterPanelProps<T>,
) {
  const { open = false, children, onSearch, schema, searchValues } = props;
  const { t } = useTranslation();
  const isMobile = useBreakpoint(down('md'));

  return (
    <>
      <ResponsiveCard noPadding>
        <FormHandler
          // NOTE La tipizzazione è già garantita dal generic T, usiamo `any`
          // per semplificare i tipi di TypeScript (qui spende 500+ms)
          schema={schema as any}
          initialValues={searchValues}
          onReset={() => onSearch(null)}
          hideVisualFeedback
          onSubmit={async rawValues => {
            try {
              const values = (await schema.validate(rawValues)) as T;
              onSearch(values);
            } catch (e) {
              console.error(`[Errore] Errore nella ricerca`, e);
            }
          }}
        >
          <GhostCollapse
            opened={open}
            button={
              <Space direction={!isMobile ? 'vertical' : undefined}>
                <Button block htmlType="reset">
                  {t('table.table-data-filter-panel.reset', 'Pulisci')}
                </Button>
                <Button
                  block
                  type="primary"
                  htmlType="submit"
                  icon={<SearchOutlined />}
                >
                  {t('table.table-data-filter-panel.search', 'Cerca')}
                </Button>
              </Space>
            }
          >
            {children}
          </GhostCollapse>
          {open && <Divider style={{ margin: 0 }} />}
        </FormHandler>
      </ResponsiveCard>
      {open && <VerticalSpace />}
    </>
  );
}
